module.exports = __webpack_public_path__ + "img/general-henry-huidekoper.1cf62c38.png";